import { AuthUser, MeResponse, PasswordLoginRequest, SupportHandoffResponse } from '@siteday/shared';
import { z } from 'zod';

import { api } from './client';

/** Web login sets httpOnly cookies; the body may or may not carry tokens (doc 05). */
const LoginResponse = z.object({ user: AuthUser }).passthrough();

export async function login(input: z.infer<typeof PasswordLoginRequest>) {
  return api.post('/auth/password/login', PasswordLoginRequest.parse(input), LoginResponse);
}

export async function me() {
  return api.get('/auth/me', MeResponse);
}

/** Fuorix support "Open read-only" (doc 13 "Support panel"): trades the one-time code for a 30-minute read-only cookie session. */
export async function supportHandoff(code: string) {
  return api.post('/auth/support-handoff', { code }, SupportHandoffResponse);
}

/** The refresh token lives in a cookie on web; the server reads it from there. */
export async function logout() {
  try {
    await api.post('/auth/logout', {});
  } catch {
    // Signing out locally is enough when the server call fails.
  }
}
